import styled from 'styled-components/native'

export const Container = styled.View.attrs(
  ({
    hasPanel,
    theme: {
      colorVars: { layout },
    },
  }) => ({
    outerPadding: hasPanel ? layout.container.padding : '0',
  }),
)`
  flex: 1;
  padding: ${props => props.outerPadding};
`

export const ElementTitleContainer = styled.View.attrs(
  ({
    theme: {
      colorVars: { layout },
    },
    hasPanel,
  }) => ({
    padding: `0 ${layout.container.padding} 0`,
    titleHeight: hasPanel ? 'auto' : '20%',
  }),
)`
  align-items: center;
  height: ${props => props.titleHeight};
  justify-content: center;
  padding: ${props => props.padding};
  text-align: center;
  width: 100%;
`

export const ElementsContainer = styled.View.attrs(
  ({
    foregroundColor,
    theme: {
      colorVars: { layout },
    },
  }) => ({
    hasPanel: foregroundColor != null,
    panelBackgroundColor: foregroundColor || 'transparent',
    panelBorderRadius: foregroundColor ? layout.textBubble.borderRadius : '0',
    panelPadding: foregroundColor ? layout.textBubble.padding : '0',
  }),
)`
  flex-direction: column;
  flex: 1;
  justify-content: center;
  background-color: ${props => props.panelBackgroundColor};
  border-radius: ${props => props.panelBorderRadius};
  padding: ${props => props.panelPadding};
`

export const Element = styled.View.attrs(({ height, width }) => ({
  frameWidth: width,
  frameHeight: height,
}))`
  height: ${props => props.frameHeight}px;
  width: ${props => props.frameWidth}px;
`
